import AdditionalAccount from '@common/types/data/additional-account';
import isEqual from 'lodash/isEqual';

const isEqualAccounts = (
  accounts1: AdditionalAccount[],
  accounts2: AdditionalAccount[]
): boolean =>
  isEqual(
    accounts1.map(({ value }) => value).sort(),
    accounts2.map(({ value }) => value).sort()
  );

export default isEqualAccounts;
